// extracted by mini-css-extract-plugin
export default {"card":"p5-z"};